<template>
  <div class="p-0 col-12 animated fadeIn">
    <kendo-datasource ref="datainbound"
        :transport-read="getInbound"
        :schema="getSchema()"
        :batch='true'
        :page-size='limit'
        :page="page"
        :server-paging='true'
        :server-sorting='true'
        :server-filtering='true'>
    </kendo-datasource>
    <kendo-grid ref="gridinbound" :data-source-ref="'datainbound'"
        :filterable='false'
        :pageable="{ pageSizes: [10, 15, 25, 50], buttonCount: 3, input: true }"
        :sortable='false'
        :resizable='true'>
      <kendo-grid-column field="arrival_date" title="Arrival Date" :format="'{0:d}'" width="120px"></kendo-grid-column>
      <kendo-grid-column field="document_number" title="Document"></kendo-grid-column>
      <kendo-grid-column field="supplier" title="Supplier" template="<span class='text-capitalize'>#= supplier.name.toLowerCase() # </span>" width="150px"></kendo-grid-column>
      <kendo-grid-column field="product" title="Product Code" template="#= product.name.toUpperCase() #"></kendo-grid-column>
      <kendo-grid-column field="items" title="Quantity"  template="#= '<span class=\'d-block text-center\'>' + quantity + '</span>' #" :format="'{0:n}'" width="120px"></kendo-grid-column>
      <kendo-grid-column field="racks" title="Location" width="100px" template="<span class='d-block text-center'>#= racks ? racks : '-' #</span>"></kendo-grid-column>
      <kendo-grid-column v-if="account.role.toUpperCase() === 'WAREHOUSE' || account.role.toUpperCase() === 'MANAGER'"
        field="commmand" title="&nbsp;" width="220px" template="#= command(dataUid) #"></kendo-grid-column>
    </kendo-grid>
  </div>
</template>

<script>
export default {
  data () {
    // data here
    return {
      button: {
        name: 'Add Inbound',
        icon: 'fa fa-plus',
        url: '/inventory/inbound/add'
      },
      page: 1,
      limit: 15,
      account: JSON.parse(localStorage.getItem('account'))
    }
  },
  created () {
    // change button if the role match
    if (this.account.role === 'MANAGER' || this.account.role === 'WAREHOUSE') {
      this.$parent.button = this.button
    }
    // set kendo culture
    window.kendo.culture('id-ID')
  },
  methods: {
    getInbound (event) {
      var vm = this
      vm.axios('api/inventory/inbound/')
        .then(
          (response) => {
            event.success(response.data)
          }
        )
    },
    getSchema () {
      return {
        data: 'results',
        total: 'count',
        parse: function (response) {
          var data = response.results
          for (var i = 0; i < data.length; i++) {
            data[i].dataUid = data[i].uid
            data[i].command = function (uid) {
              var account = JSON.parse(localStorage.getItem('account'))
              if (account.role.toUpperCase() !== 'WAREHOUSE' && account.role.toUpperCase() !== 'MANAGER') {
                return ''
              }
              var command = '<div class="text-center" style="padding: 5px;">' +
                            '<a href="/#/inventory/inbound/edit/' + uid + '" class="btn btn-outline-primary d-inline"><i class="fa fa-edit"></i>&nbsp;Edit</a>&nbsp;' +
                            '<a href="/#/inventory/inbound/item/add/' + uid + '" class="btn btn-outline-warning d-inline"><i class="fa fa-plus"></i>&nbsp;Add Item</a>' +
                            '</div>'
              return command
            }
          }
          return response
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/inbound/Inbound.vue